import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { delayedRetry } from '../../../../projects/platform-manager/src/lib/services/DEFAULT_MAX_RETRIES';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';
import { ZoominResponseInterface } from '../interfaces/zoomin-response-interface';

@Injectable({
  providedIn: 'root'
})
export class ZoomInService {
  protected headers = new HttpHeaders({ Accept: 'application/json' });

  constructor(
    private client: HttpClient,
    private platform: PlatformInformationService,
    private translateService: TranslateService,
    private transferState: TransferState
  ) {}

  getZoomInData(): Observable<ZoominResponseInterface> {
    const url = this.getZoomInApi(this.translateService.currentLang);
    const zoomInKey = makeStateKey<ZoominResponseInterface>('zoomInResult');
    if (this.transferState.hasKey(zoomInKey)) {
      const countries = this.transferState.get<ZoominResponseInterface>(zoomInKey, null);
      this.transferState.remove(zoomInKey);
      return of(countries);
    }

    return this.client.get<ZoominResponseInterface>(url, { headers: this.headers, observe: 'response' }).pipe(
      delayedRetry(3000),
      map(response => {
        if (!this.platform.getIsBrowser() && response.status === 200) {
          this.transferState.set(zoomInKey, response.body);
        }
        return response.body;
      }),
      catchError(() => {
        return throwError(() => new Error('Could not load countries from: ' + url));
      })
    );
  }

  /**
   * @param lang - language short code (eg. en, de,...)
   *
   * @Returns string - url containing given lang (eg. /en/)
   */
  public getZoomInApi(lang: string): string {
    return this.platform.getApiEndpointFor('getZoomInApi').replace('%lang%', lang);
  }
}
